import { FournisseurType } from '../models';

export class    SepaForm {

    public SupplierId: FournisseurType;
    public ThirdPartyId: number;
    public PayerCompanyName: string;
    public PayerLastName: string;
    public PayerFirstName: string;
    public PayerStreetAddress: string;
    public PayerZipCode: string;
    public PayerCity: string;
    public PayerCountry: string;
    public PayerAccountIBAN: string;
    public PayerAccountBIC: string;

    public static extractData(response: any): SepaForm {
        const body = response.json();
        const result = new SepaForm();
        Object.assign(result, body);
        return body;
    }

}
